<template>
    <span>
        <el-form-item :label="label" > 
            <span v-for="(img,index) in imgs" :key="index">     
                <el-image
                    class="style-img"
                    :src="img" 
                    :preview-src-list="srcList">
                </el-image>   
            </span>          
        </el-form-item>         
    </span>
</template>
<script>
export default { 
    data(){
        return{
            srcList:[],   
            imgs:[],
        }
    },
    props:{   
        objImgUrl: {
            type: String
        },  
        label:{
            type:String,
        },
        tprop:{
            type:Object
        }
    },
    watch: { 
        tprop: {
            handler(newVal,oldVal) {
                if(newVal!=oldVal){
                    this.getImgs();
                } 
                
            },
            immediate: true,
            deep: true
        },

    },
    created(){
        this.getImgs();
    },
    methods:{
        getImgs:function(){
            let b = false;
            if(this.tprop){
                if(this.tprop.propertyValue){
                    let imgUrls = this.tprop.propertyValue ;
                    this.imgs = imgUrls.split(",");
                    this.srcList =this.imgs;
                    b = true;
                }                
            }
            if(!b){
                this.imgs=[];
            }
        }
    }

}
</script>
<style lang="scss"  >
    .style-img{
        width: 120px;
        height: 60px;
        margin-left:10px;
        margin-top:5px;
    }
</style>